// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3868":"0b18557d23a506ed","4453":"641f027b893efba7"}[chunkId] + ".js";
};